import type { Service } from '../types/content';
import { images } from './business';

export const services: Service[] = [
  {
    id: 'resurfacing',
    title: 'Pool Resurfacing',
    description:
      'Replace a rough, stained, or etched surface with a smooth new finish that looks clean and feels good underfoot.',
    image: images.plaster,
    imageAlt: 'Crew member troweling fresh plaster inside an empty pool',
    details: [
      'Draining and prep of the existing surface',
      'Repair of cracks and hollow spots before finishing',
      'Plaster, quartz, and pebble-style finish options',
      'Startup and water balancing guidance',
    ],
    formOption: 'Pool Resurfacing',
  },
  {
    id: 'plaster',
    title: 'New Plaster',
    description:
      'A fresh white or colored plaster finish for pools that have lost their brightness and smooth texture.',
    image: images.after,
    imageAlt: 'Pool with new white plaster and clear aqua water',
    details: [
      'Classic white and colored plaster options',
      'Removal of failing or delaminated plaster',
      'Even, smooth finish across walls, steps, and floor',
      'Care instructions for the first weeks after fill',
    ],
    formOption: 'New Plaster',
  },
  {
    id: 'waterline-tile',
    title: 'Waterline Tile',
    description:
      'Swap dated or damaged waterline tile for a clean, modern band that frames the whole pool.',
    image: images.tile,
    imageAlt: 'New blue glass mosaic waterline tile under travertine coping',
    details: [
      'Removal of old, cracked, or stained tile',
      'Glass, porcelain, and stone tile options',
      'Clean grout lines sealed for Florida conditions',
      'Easy to pair with resurfacing or new coping',
    ],
    formOption: 'Tile & Coping',
  },
  {
    id: 'tile-coping',
    title: 'Tile & Coping',
    description:
      'Repair or replace cracked, loose, or outdated coping and tile along the edge of your pool.',
    image: images.hero,
    imageAlt: 'Renovated pool with new tile and travertine coping inside a screened lanai',
    details: [
      'Repair of loose or cracked coping stones',
      'Full coping replacement in travertine, brick, or pavers',
      'Matching or upgraded waterline tile',
      'A clean, safe edge for swimmers',
    ],
    formOption: 'Tile & Coping',
  },
  {
    id: 'decks',
    title: 'Pavers & Decks',
    description:
      'Update a faded or cracked pool deck with pavers that look fresh and are comfortable to walk on.',
    image: images.deck,
    imageAlt: 'New travertine paver deck around a residential pool',
    details: [
      'Travertine and concrete paver options',
      'Paver installation over existing decks where suitable',
      'Proper slope and drainage away from the pool',
      'Sealing options to help resist stains',
    ],
    formOption: 'Pavers / Deck',
  },
  {
    id: 'equipment',
    title: 'Equipment Repairs',
    description:
      'Diagnose and repair pumps, filters, heaters, and plumbing so your pool runs the way it should.',
    image: images.equipment,
    imageAlt: 'Clean pool equipment pad with pump, filter, and new plumbing',
    details: [
      'Pump, filter, and heater troubleshooting',
      'Leak checks on equipment and plumbing',
      'Equipment replacement and upgrades',
      'Plumbing and valve repairs at the pad',
    ],
    formOption: 'Equipment Repair',
  },
];
